// export const sidebarFilterRoutes = (routes, hasPermission) => {
// 	return routes
// 		.map((route) => {
// 			// keep routes without moduleId always
// 			if (!route.moduleId) {
// 				const children = route.children
// 					? sidebarFilterRoutes(route.children, hasPermission)
// 					: undefined;

// 				return { ...route, children };
// 			}

// 			// module-level permission check
// 			if (!hasPermission(route.moduleId)) {
// 				return null;
// 			}

// 			// if module has children, filter each child with (moduleId, childId)
// 			const children = route.children
// 				? route.children.filter((child) =>
// 						hasPermission(route.moduleId, child.id)
// 					)
// 				: undefined;

// 			return { ...route, children };
// 		})
// 		.filter(
// 			(route) =>
// 				route &&
// 				// include non-nested routes
// 				(!route.isNested ||
// 					// include nested routes only if children exist
// 					(route.isNested &&
// 						Array.isArray(route.children) &&
// 						route.children.length > 0))
// 		);
// };

/**
 * May this sidebar entry / route be shown?
 *
 * ★ ONE PREDICATE FOR THE SIDEBAR AND THE ROUTER. The layout's route filter
 * calls this too, so a link can never appear for a screen the router then
 * refuses, or the reverse.
 *
 * Resolution, in order:
 *   - `anyOf: [[moduleId, actionKey], ...]` — shown if ANY pair is granted.
 *     For a screen that belongs to two modules at once (the WhatsApp settings
 *     page hosts both the classic and the Meta settings as tabs).
 *   - `moduleId` + `id` — a child may name its OWN module. The default is the
 *     parent's, which is what every child relies on today; a child that belongs
 *     to another module may declare its own and is checked against that.
 *
 * @param {Function} hasPermission  (moduleId, actionKey?) => boolean
 * @param {object} entry            { moduleId?, id?, anyOf? }
 * @param {string} [parentModuleId] the group's module, for children
 */
export const permissionAllows = (hasPermission, entry, parentModuleId) => {
  if (Array.isArray(entry.anyOf) && entry.anyOf.length) {
    return entry.anyOf.some(([moduleId, actionKey]) => hasPermission(moduleId, actionKey));
  }
  const moduleId = entry.moduleId ?? parentModuleId;
  if (!moduleId) return true;
  return hasPermission(moduleId, entry.id);
};

export const sidebarFilterRoutes = (routes, hasPermission) => {
  return routes
    .map((route) => {
      // keep routes without moduleId and without id always (like Dashboard)
      if (!route.moduleId && !route.id) {
        const children = route.children
          ? sidebarFilterRoutes(route.children, hasPermission)
          : undefined;
        return { ...route, children };
      }

      // NEW: Handle standalone routes with both moduleId and id (like Employee Loans)
      if (route.moduleId && route.id) {
        // Check permission for this specific action
        if (!permissionAllows(hasPermission, route)) {
          return null;
        }
        return route;
      }

      // Each child resolves against its own module when it names one, else
      // the group's. Filtered BEFORE the group check so a group whose module
      // the user lacks can still appear for the children they do hold — a
      // Meta-only agent sees the WhatsApp group with just the Meta entries.
      const children = route.children
        ? route.children.filter((child) =>
            permissionAllows(hasPermission, child, route.moduleId)
          )
        : undefined;

      // Regular module-level permission check
      if (!hasPermission(route.moduleId) && !(children && children.length)) {
        return null;
      }

      return { ...route, children };
    })
    .filter(
      (route) =>
        route &&
        // include non-nested routes
        (!route.isNested ||
          // include nested routes only if children exist
          (route.isNested &&
            Array.isArray(route.children) &&
            route.children.length > 0))
    );
};
export const safeStorage = {
	get(key) {
		try {
			if (typeof window === 'undefined') return null;
			return window.localStorage.getItem(key);
		} catch {
			return null;
		}
	},
	set(key, value) {
		try {
			if (typeof window === 'undefined') return;
			window.localStorage.setItem(key, value);
		} catch {}
	},
};
